import React, { createRef } from "react";

import styled from "styled-components";

import MenuImported from "./menu";
import PropertyEditorImported from "./propertyeditor";

import { FacebookShareButton, FacebookIcon } from "react-share";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShare, faFileDownload } from "@fortawesome/free-solid-svg-icons";

export const Menu = (props) => <MenuImported {...props} />;
export const PropertyEditor = (props) => <PropertyEditorImported {...props} />;

const GalleryContainer = styled.div`
  column-count: 5;
  column-gap: 0px;
  line-height: 0;

  /* Extra small devices (phones, 600px and down) */
  @media only screen and (max-width: 480px) {
    column-count: 2;
  }

  /* Small devices (portrait tablets and large phones, 600px and up) */
  @media only screen and (min-width: 480px) {
    column-count: 2;
  }

  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) {
    column-count: 3;
  }

  /* Large devices (laptops/desktops, 992px and up) */
  @media only screen and (min-width: 992px) {
    column-count: 4;
  }

  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1200px) {
    column-count: 5;
  }
`;

const StyledImageContainer = styled.div`
  position: relative;
  display: inline-block;
  background-color: #1d1d1d;
  padding: 10px;
  border: 1px white solid;

  :hover {
    background-color: #3d3d3d;
  }
  width: 100%;
`;

const StyledImage = styled.img`
  width: 100%;
  display: block;
`;

const StyledBackground = styled.div`
  background-color: rgba(0, 0, 0, 0.9);
  z-index: 99;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
`;

const SelectedContentContainer = styled.div`
  //background-color: red;
  //z-index: 99;
  //position: relative;
  //top: 0;
  //bottom: 0;
  //left: 0;
  //right: 0;
  //width: 100%;
  //max-width: 100%;
  width: 100%;
  height: 100%;
  //max-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SelectedImageContainer = styled.div`
  //display: flex;
  //align-items: center;
  position: relative;
  height: 100%;
  //max-height: 100%;
  //--
  //width: 100%;
  //background-color: red;
`;

const SelectedStyledImage = styled.img`
  //height: 100%;
  //position: absolute;
  display: block;

  max-width: 100%;
  max-height: 100%;
`;

const CloseButton = styled.button`
  position: absolute;
  right: 0;
  top: 0;
  font-size: 30x;

  width: 60px;
  height: 60px;

  font-family: Roboto;

  margin: 2px;

  background-color: rgba(180, 180, 180, 0.3);
  color: white;
  border: 2px solid black;

  transition-duration: 0.4s;

  border-radius: 50%;

  :hover {
    background-color: rgba(100, 100, 100, 1);
    color: white;
  }
`;

const AbsoluteBottomRight = styled.div`
  position: absolute;
  bottom: 10px;
  right: 10px;
  width: 35px;
  height: 35px;
  //background-color: red;
  overflow: hidden;
`;

const AbsoluteBottomLeft = styled.div`
  position: absolute;
  bottom: 10px;
  left: 10px;
  width: 35px;
  height: 35px;
  //background-color: red;
  overflow: hidden;
`;

const ShareButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 35px;
  height: 35px;
  border-radius: 100%;
  border: 1px solid black;
  color: white;
`;

const HiddenA = styled.a`
  display: none;
`;

const Share = ({ url, title }) => {
  if (typeof navigator !== "undefined" && navigator.share) {
    return (
      <ShareButton onClick={() => navigator.share({ url, title })}>
        <FontAwesomeIcon icon={faShare} />
      </ShareButton>
    );
  } else {
    return (
      <FacebookShareButton url={url}>
        <FacebookIcon size={35} round={true}></FacebookIcon>
      </FacebookShareButton>
    );
  }
};

const Main = ({ images, selectedImage, onImageClick, onImageClose }) => {
    const downloadLinkRef = createRef();
  return (
    <>
      <GalleryContainer>
        {images.map((item, index) => (
          <StyledImageContainer
            key={item.key}
            onClick={() => onImageClick(item)}
          >
            <StyledImage src={item.src} srcSet={item.srcSet} />
          </StyledImageContainer>
        ))}
      </GalleryContainer>
      {selectedImage && (
        <StyledBackground>
          <SelectedContentContainer>
            <SelectedImageContainer>
              <SelectedStyledImage
                src={selectedImage.src}
                srcSet={selectedImage.srcSet}
              ></SelectedStyledImage>
              <CloseButton onClick={onImageClose}>X</CloseButton>
              <AbsoluteBottomRight>
                <Share
                  url={`https://chrisandquynh.com/jackson/${selectedImage.key}`}
                  title={"Jackson Photo"}
                ></Share>
              </AbsoluteBottomRight>
              <AbsoluteBottomLeft>
                <HiddenA
                  ref={downloadLinkRef}
                  href={selectedImage.src}
                  download
                >Hidden</HiddenA>
                <ShareButton onClick={() => downloadLinkRef.current.click()}>
                  <FontAwesomeIcon icon={faFileDownload} />
                </ShareButton>
              </AbsoluteBottomLeft>
            </SelectedImageContainer>
          </SelectedContentContainer>
        </StyledBackground>
      )}
    </>
  );
};

export default Main;
